/* eslint-disable eslint-comments/disable-enable-pair */
import DateUtils from '../../../utils/date';
import { routerSelector } from '@shared/store/slices/router.slice';
import { useAppSelector } from '@shared/store/hooks';
import { useCallback, useEffect, useState } from 'react';

export default function withClock(
  TextElement: React.ElementType,
  {
    displaySeconds = true,
    displayMinutes = true,
    displayHours = true,
    displayDay = false,
    displayDayOfWeek = false,
    displayMonth = false,
    displayMonthPreposition = false,
  },
  style?: React.CSSProperties | React.CSSProperties[]
) {
  return () => {
    const getClockTime = useCallback(() => {
      return DateUtils.getTime({
        displaySeconds,
        displayMinutes,
        displayHours,
        displayDay,
        displayDayOfWeek,
        displayToday: false,
        displayMonth,
        displayMonthPreposition,
      });
    }, []);
    const { route } = useAppSelector(routerSelector);
    const [currentTime, setCurrentTime] = useState(getClockTime());
    useEffect(() => {
      setCurrentTime(getClockTime());
      let clockInterval: NodeJS.Timeout | undefined = undefined;
      let timeInterval = 0;
      if (displayDay || displayDayOfWeek || displayMonth)
        timeInterval = 60 * 60 * 1000;
      if (displayHours) timeInterval = 60 * 60 * 1000;
      if (displayMinutes) timeInterval = 60 * 1000;
      if (displaySeconds) timeInterval = 1 * 1000;
      clockInterval = setInterval(() => {
        setCurrentTime(getClockTime());
      }, timeInterval);
      return () => clearInterval(clockInterval);
    }, [route.Page]);
    return <TextElement style={style ? style : {}}>{currentTime}</TextElement>;
  };
}
